<script>
  import { navigate } from 'svelte-routing';

  export let params = {};

  let error = null;

  // Categories are browsed from the sidebar now; a bare /help/:category URL
  // just opens the category's first doc.
  $: resolve(params.category || pathCategory());

  function pathCategory() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return parts.length >= 2 && parts[0] === 'help' ? parts[1] : '';
  }

  async function resolve(cat) {
    if (!cat) { error = 'No category specified'; return; }
    try {
      const res = await fetch('/content/help-manifest.json');
      if (!res.ok) throw new Error('Could not load help manifest.');
      const manifest = await res.json();
      const data = manifest.categories[cat];
      if (!data || !(data.files || []).length) {
        error = `Category "${cat}" not found`;
        return;
      }
      const first = data.files.slice().sort((a, b) => a.position - b.position)[0];
      navigate(`/help/${cat}/${first.slug}`, { replace: true });
    } catch (err) {
      error = err.message;
    }
  }
</script>

<div class="min-h-screen bg-gray-50 flex items-center justify-center">
  <div class="text-center">
    {#if error}
      <p class="text-red-600 mb-4">{error}</p>
      <a href="/help" class="text-blue-600 hover:text-blue-800 font-medium">Back to Help Center</a>
    {:else}
      <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      <p class="mt-3 text-gray-600">Opening…</p>
    {/if}
  </div>
</div>
